// removed by extract-text-webpack-plugin
module.exports = {"Container":"DeleteUser__Container__KnmgE","Btn":"DeleteUser__Btn__15yL6","RedBtn":"DeleteUser__RedBtn__37L6B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserController/DeleteUser/DeleteUser.css
// module id = 113
// module chunks = 0